// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_fk-0";